import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Logo from "../../assest/logo.png";
import Home from "../../assest/home.png";
import Menu from "../../assest/burger-menu.png";
import { Sidebar } from "primereact/sidebar";
import Sidebarleft from "./Sidebar";

const Topbar = ({ Go_Home, modal_opt, ModalHandler }) => {
  return (
    <div className="home-screen ">
      <div className="top-bar border-b-2">
        <div className="h-full flex justify-between item-center py-2">
          <div className="w-36 max-[440px]:w-26">
            <img src={Logo} alt="" className="w-full" />
          </div>
          <div className="flex items-center">
            <button className="mx-3 text-3xl text-[#f79221]" onClick={Go_Home}>
              <img src={Home} alt="" className="w-11" />
            </button>
            <button
              className="mx-3 text-3xl text-[#f79221]"
              onClick={() => ModalHandler("sidebar", true)}
            >
              <img src={Menu} alt="" className="w-8 h-6" />
            </button>
          </div>
        </div>

        {/* PRIME SIDEBAR  START*/}
        <div className="card flex justify-content-center">
          <Sidebar
            visible={modal_opt?.sidebar}
            position="right"
            onHide={() => ModalHandler("sidebar", false)}
          >
            <Sidebarleft ModalHandler={ModalHandler} />
          </Sidebar>
          {/* <Button icon="pi pi-arrow-right" onClick={() => setVisible(true)} /> */}
        </div>
        {/* PRIME SIDEBAR  END*/}
      </div>
      <div className="home-holder">
        <Outlet />
      </div>
    </div>
  );
};

export default Topbar;
